
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { Logger } from './services/Logger';
import './index.css';

// Global error handlers
window.addEventListener('error', (event) => {
  Logger.error(event.error || event.message, {
    type: 'UNCAUGHT_EXCEPTION',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  Logger.error(event.reason, {
    type: 'UNHANDLED_REJECTION',
  });
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
